export default "__VITE_ASSET__BKIcH2RW__"